import React, { useState } from 'react';

import styles from '../Styles/DiagnosticBPage.module.css';
import axios from 'axios';

import { useDiagnostico } from './../../../context/DiagnosticoContext/DiagnosticoHook';
import { useFormContext } from 'react-hook-form';
import ChartRadar from '../Chart/ChartRadar';
import { calcularPorcentajes } from '../../../utilities/calculateFormB';
import ChartMeasurer from '../Chart/ChartMeasurer';
import { getSearchParams } from '../../../utilities/getSearchParams';
function EndOfDiagnostic() {
  const {
    setInfoForm,
    formDataInputsDiagnosticB,
    changeStateEndOfDiagnosticFn,
    idQuestions,
  } = useDiagnostico();
  const { handleSubmit, watch, setValue } = useFormContext();
  const realDataTimeForm = watch('secciones');
  const [isLoading, setIsLoading] = useState(false);

  const Submit = async (e) => {
    const { id_key } = getSearchParams();

    e.preventDefault();
    // Asegurándonos de que handleSubmit sea una función antes de invocarla
    if (typeof handleSubmit !== 'function') return;
    try {
      setIsLoading(true);
      await handleSubmit(async (item) => {
        // Validación de las secciones
        if (!item.secciones) {
          console.error('Secciones no definidas');
          setIsLoading(false);
          return;
        }
        const { resultados, porcentajeTotal } = calcularPorcentajes(
          item.secciones,
        );

        // Construcción de objectSendOpen con validación de formDataInputsDiagnosticB
        const objectSendOpen = {
          enterpriceName: 'Growty',

          finalCalc: porcentajeTotal,
          dataUser: {
            name: formDataInputsDiagnosticB?.name ?? '',
            email: formDataInputsDiagnosticB?.email ?? '',
            phone: formDataInputsDiagnosticB?.phone ?? '',
            companyIndustry:
              item.secciones?.['sec1']?.['preg2']?.text ||
              'Nombre no disponible',
            company:
              item.secciones?.['sec1']?.['preg1']?.text ||
              'Nombre no disponible',
            companyDescription:
              item.secciones?.['sec1']?.['preg6']?.text ||
              'Descripción no disponible',
          },
          idKeyForm: id_key ?? '',
          imgChart: {
            radar: item.chatRadarImg,
            measurer: item.chatMeasurerImg,
          },
          dataDiagnostic: [
            {
              titleCategory: 'Estrategia digital y empresarial',
              // Asegúrate de que `resultados['sec3']` exista y tenga un `porcentaje` antes de acceder a él
              percentage: resultados['sec3']?.porcentaje ?? 0, // 0 o algún valor predeterminado si no está definido
            },
            {
              titleCategory: 'Experiencia de cliente',
              percentage: resultados['sec4']?.porcentaje ?? 0,
            },
            {
              titleCategory: 'Cultura innovadora y liderazgo',
              percentage: resultados['sec5']?.porcentaje ?? 0,
            },
            {
              titleCategory:
                'Estado legal en entornos digitales y empresariales',
              percentage: resultados['sec6']?.porcentaje ?? 0,
            },
            {
              titleCategory: 'Nivel tecnológico y de automatización',
              percentage: resultados['sec7']?.porcentaje ?? 0,
            },
            {
              titleCategory: 'Gestión del riesgo',
              percentage: resultados['sec8']?.porcentaje ?? 0,
            },
          ],
        };
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/pdfDiagnostic/generatePdfDiagnosticB`,
          {
            idRef: idQuestions,
            data: objectSendOpen,
            nameTemplate: 'diagnosticPrototype2.html',
          },
        );
        // Verificación del estado de la respuesta
        if (res.status === 200 || res.status === 201) {
          changeStateEndOfDiagnosticFn(true);
        } else {
          console.error('Respuesta inesperada de la API', res.status);
        }
      })();
    } catch (error) {
      console.error('Error durante la ejecución:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="formulario-datos-container">
      <div className="formulario-datos">
        <h2>¡Es momento de actuar!</h2>
        <p className="mensaje">Ya participaron personas.</p>{' '}
        <p>
          En la era digital, el crecimiento empresarial, la estrategia, el
          branding, la infraestructura tecnológica, la cultura de innovación y
          la transformación digital son esenciales para el éxito.
        </p>{' '}
        <p>
          Con las MiPymes generando el 67% del empleo en LATAM (BID) y la
          necesidad de estrategias empresariales ágiles (McKinsey), junto con el
          impacto del contenido visual en el marketing digital (HubSpot) y la
          proyección de un aumento en el uso de servicios de nube (Gartner), la
          innovación se convierte en un imperativo. Además, empresas líderes en
          digitalización reportan mejoras significativas en satisfacción del
          cliente y retención de empleados (SAP). Este panorama destaca la
          urgencia de adaptarse, innovar y digitalizarse. Invertir en estos
          aspectos no es solo una opción, sino una necesidad estratégica para
          destacar en el mercado actual.
        </p>{' '}
        <p>
          ¡Es el momento de transformar tu empresa y liderar el camino hacia el
          éxito digital!
        </p>{' '}
        <p>
          Tú ya has dado el primer paso. Invita a alguien más a compartir su
          ubicación en este entorno digital.
        </p>
        <form onSubmit={Submit}>
          <div className="input-group">
            <input
              placeholder="Nombre completo"
              id="nombre"
              type="text"
              value={formDataInputsDiagnosticB?.name || ''}
              onChange={(e) => {
                setInfoForm({ value: e.target.value, input: 'name' });
              }}
              required
            />
          </div>
          <div className="input-group">
            <input
              placeholder="Correo electrónico"
              id="email"
              type="email"
              value={formDataInputsDiagnosticB?.email || ''}
              onChange={(e) => {
                setInfoForm({ value: e.target.value, input: 'email' });
              }}
              required
            />
          </div>
          <div className="input-group">
            <input
              placeholder="Número de teléfono"
              id="telefono"
              type="tel"
              value={formDataInputsDiagnosticB?.phone || ''}
              onChange={(e) => {
                setInfoForm({ value: e.target.value, input: 'phone' });
              }}
              required
            />
          </div>
          <button
            type="submit"
            className="btn-enviar btn btn-primary btn-comenzar"
            disabled={isLoading}
          >
            {isLoading ? 'Enviando...' : 'Enviar'}
          </button>
          <span className={styles.tyc}>
            Al hacer clic en &quot;Enviar&quot;, confirmas que has leído y
            aceptas nuestros{' '}
            <a
              target="_blank"
              href="https://growtty.com/terminos-y-condiciones/"
              className={{ textDecoration: 'underline' }}
              rel="noreferrer"
            >
              Términos y Condiciones
            </a>
            y
            <a
              target="_blank"
              href="https://growtty.com/politicas-de-privacidad/"
              className={{ textDecoration: 'underline' }}
              rel="noreferrer"
            >
              Política de Privacidad
            </a>
            .
          </span>
        </form>
      </div>
      <ChartMeasurer setValue={setValue} realDataTimeForm={realDataTimeForm} />
      <ChartRadar setValue={setValue} realDataTimeForm={realDataTimeForm} />
    </div>
  );
}

export default EndOfDiagnostic;
